import { useContext, useEffect } from 'react'

import { Tabs } from 'antd'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClinicMedical, faUser } from '@fortawesome/pro-solid-svg-icons'

import { InstitutionGroupContext } from '../../../Providers/InstitutionGroupProvider'
import Analytics from '../../../utils/analytics'
import UsersView from '../UsersView/UsersView'
import InstitutionGroupFormModal from '../../../HOC/Forms/InstitutionGroupFormModal'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

import '../../../assets/institution-settings.scss'
import InstitutionGroupView from '../../institutionGroup/Settings/InstitutionGroupView'

const { TabPane } = Tabs

const InstitutionGroupSettingsView = () => {
  const { setInstitutionGroup } = useContext(InstitutionGroupContext)

  const t = useSelector(selectTranslate)

  useEffect(() => {
    Analytics.pageView('/institution-settings')
  }, [])

  return (
    <Tabs defaultActiveKey='1' animated={false}>
      <TabPane
        key='1'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faUser} style={{ marginTop: '3px' }} />
            <div className='h-spacing' />
            {t('Manage users')}
          </div>
        }
      >
        <UsersView />
      </TabPane>
      <TabPane
        key='2'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faClinicMedical} style={{ marginTop: '3px' }} />
            <div className='h-spacing' />
            {t('settings_view.institution_group_tab.title')}
          </div>
        }
      >
        <InstitutionGroupFormModal onSave={setInstitutionGroup}>
          <InstitutionGroupView />
        </InstitutionGroupFormModal>
      </TabPane>
    </Tabs>
  )
}

export default InstitutionGroupSettingsView
